import type { FC } from "react";

import { DailyRanking, Keywords, OpenFolder, Search, Spend, Users, type IconProps } from "@similarweb/icons";

import {
    ADDON_TYPE_NAME_DICT,
    getAddonTypeFromName,
    type AddOnType,
    type AddonTypeName,
} from "app/contexts/AddonStateContext/const";
import { NO_TOUCH_PURCHASE_TRANSLATIONS } from "app/components/no-touch-purchase-modal/translations";

export interface INoTouchSuggestion {
    icon: FC<IconProps>;
    titleKey: string;
    descriptionKey: string;
    addon: AddonTypeName;
}

const historyHookSuggestion: INoTouchSuggestion = {
    icon: DailyRanking,
    titleKey: NO_TOUCH_PURCHASE_TRANSLATIONS.suggestions[ADDON_TYPE_NAME_DICT.HistoricalDataDynamic].title,
    descriptionKey: NO_TOUCH_PURCHASE_TRANSLATIONS.suggestions[ADDON_TYPE_NAME_DICT.HistoricalDataDynamic].description,
    addon: ADDON_TYPE_NAME_DICT.HistoricalDataDynamic,
};

const dataCreditsHookSuggestion: INoTouchSuggestion = {
    icon: Spend,
    titleKey: NO_TOUCH_PURCHASE_TRANSLATIONS.suggestions[ADDON_TYPE_NAME_DICT.DataCreditsDynamic].title,
    descriptionKey: NO_TOUCH_PURCHASE_TRANSLATIONS.suggestions[ADDON_TYPE_NAME_DICT.DataCreditsDynamic].description,
    addon: ADDON_TYPE_NAME_DICT.DataCreditsDynamic,
};

const userHookSuggestion: INoTouchSuggestion = {
    icon: Users,
    titleKey: NO_TOUCH_PURCHASE_TRANSLATIONS.suggestions[ADDON_TYPE_NAME_DICT.AdditionalUsersDynamic].title,
    descriptionKey: NO_TOUCH_PURCHASE_TRANSLATIONS.suggestions[ADDON_TYPE_NAME_DICT.AdditionalUsersDynamic].description,
    addon: ADDON_TYPE_NAME_DICT.AdditionalUsersDynamic,
};

const keywordsHookSuggestion: INoTouchSuggestion = {
    icon: Keywords,
    titleKey: NO_TOUCH_PURCHASE_TRANSLATIONS.suggestions[ADDON_TYPE_NAME_DICT.SeoKeywordsDynamic].title,
    descriptionKey: NO_TOUCH_PURCHASE_TRANSLATIONS.suggestions[ADDON_TYPE_NAME_DICT.SeoKeywordsDynamic].description,
    addon: ADDON_TYPE_NAME_DICT.SeoKeywordsDynamic,
};

const campaignsHookSuggestion: INoTouchSuggestion = {
    icon: Search,
    titleKey: NO_TOUCH_PURCHASE_TRANSLATIONS.suggestions[ADDON_TYPE_NAME_DICT.SeoCampaignsDynamic].title,
    descriptionKey: NO_TOUCH_PURCHASE_TRANSLATIONS.suggestions[ADDON_TYPE_NAME_DICT.SeoCampaignsDynamic].description,
    addon: ADDON_TYPE_NAME_DICT.SeoCampaignsDynamic,
};

const projectsHookSuggestion: INoTouchSuggestion = {
    icon: OpenFolder,
    titleKey: NO_TOUCH_PURCHASE_TRANSLATIONS.suggestions[ADDON_TYPE_NAME_DICT.AdditionalProjectsDynamic].title,
    descriptionKey:
        NO_TOUCH_PURCHASE_TRANSLATIONS.suggestions[ADDON_TYPE_NAME_DICT.AdditionalProjectsDynamic].description,
    addon: ADDON_TYPE_NAME_DICT.AdditionalProjectsDynamic,
};

export const getNTPurchaseSuggestions = (
    addonTitle: AddonTypeName,
    getIsAddonAvailable: (addonType: AddOnType) => boolean,
): INoTouchSuggestion[] => {
    const choicePool: INoTouchSuggestion[] = [
        historyHookSuggestion,
        dataCreditsHookSuggestion,
        userHookSuggestion,
        keywordsHookSuggestion,
        campaignsHookSuggestion,
        projectsHookSuggestion,
    ];

    return choicePool
        .filter((choice) => {
            const addonTypeName = choice.addon;
            return getIsAddonAvailable(getAddonTypeFromName(addonTypeName)) && addonTitle !== addonTypeName;
        })
        .slice(0, 2);
};
